var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#close_svg__clip0_7936_108799)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.442 4.558a.625.625 0 010 .884L10.884 10l4.558 4.558a.625.625 0 11-.884.884L10 10.884l-4.558 4.558a.625.625 0 11-.884-.884L9.116 10 4.558 5.442a.625.625 0 01.884-.884L10 9.116l4.558-4.558a.625.625 0 01.884 0z",
    fill: "#3F465C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "close_svg__clip0_7936_108799"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h20v20H0z"
  })))));
}
export default __webpack_public_path__ + "static/close.e4c4e551.svg";
export { SvgClose as ReactComponent };